import React, { useState, useEffect, useRef } from 'react';

// Demo customer data - Eastern PA businesses
const DEMO_CUSTOMERS = [
  { id: 1, name: "Liberty Manufacturing", contact: "John Smith", email: "john@libertymfg.com", phone: "(215) 555-1234", address: "1500 Market St, Philadelphia, PA", lat: 39.9526, lng: -75.1652, lathes: [{ type: "9.0", quantity: 2 }, { type: "X9", quantity: 1 }], lastContact: "2024-12-28", notes: [
    { text: "Interested in enterprise plan", timestamp: "2024-12-28" }
  ]},
  { id: 2, name: "Keystone Tech Solutions", contact: "Sarah Johnson", email: "sarah@keystonetech.com", phone: "(484) 555-2345", address: "455 Business Center Dr, Allentown, PA", lat: 40.6023, lng: -75.4714, lathes: [{ type: "X15", quantity: 3 }], lastContact: "2024-06-25", notes: [
    { text: "Follow up on pricing", timestamp: "2024-06-25" }
  ]},
  { id: 3, name: "Delaware Valley Logistics", contact: "Michael Chen", email: "mchen@dvlogistics.com", phone: "(610) 555-3456", address: "789 Industrial Pkwy, Norristown, PA", lat: 40.1215, lng: -75.3399, lathes: [{ type: "X19", quantity: 1 }, { type: "B17", quantity: 2 }], lastContact: "2024-11-15", notes: [
    { text: "Renewal coming up in Q1", timestamp: "2024-11-15" }
  ]},
  { id: 4, name: "Pocono Business Group", contact: "Emily Rodriguez", email: "emily@poconobiz.com", phone: "(570) 555-4567", address: "321 Mountain View Dr, Stroudsburg, PA", lat: 40.9865, lng: -75.1946, lathes: [{ type: "9.2", quantity: 1 }], lastContact: "2024-03-20", notes: [
    { text: "Needs demo scheduled", timestamp: "2024-03-20" }
  ]},
  { id: 5, name: "Lehigh Innovations", contact: "David Park", email: "dpark@lehighinnovate.com", phone: "(610) 555-5678", address: "654 Tech Blvd, Bethlehem, PA", lat: 40.6259, lng: -75.3705, lathes: [{ type: "X9d", quantity: 2 }, { type: "X1", quantity: 1 }], lastContact: "2024-12-15", notes: [
    { text: "Very happy customer", timestamp: "2024-12-15" }
  ]},
  { id: 6, name: "Main Line Consulting", contact: "Lisa Wang", email: "lisa@mainlineconsult.com", phone: "(610) 555-6789", address: "987 Lancaster Ave, Wayne, PA", lat: 40.0442, lng: -75.3877, lathes: [{ type: "9.0", quantity: 1 }], lastContact: "2023-10-15", notes: [
    { text: "Contract ended, potential renewal", timestamp: "2023-10-15" }
  ]},
  { id: 7, name: "Reading Industrial Supply", contact: "Robert Martinez", email: "rmartinez@readingsupply.com", phone: "(610) 555-7890", address: "147 Penn St, Reading, PA", lat: 40.3356, lng: -75.9269, lathes: [{ type: "X15", quantity: 2 }, { type: "B17", quantity: 1 }], lastContact: "2024-10-26", notes: [
    { text: "Expanding to new regions", timestamp: "2024-10-26" }
  ]},
  { id: 8, name: "Chester County Systems", contact: "Amanda Lee", email: "alee@chestersystems.com", phone: "(610) 555-8901", address: "258 Business Park Dr, West Chester, PA", lat: 39.9606, lng: -75.6055, lathes: [{ type: "X9", quantity: 1 }], lastContact: "2024-05-22", notes: [
    { text: "Comparing with competitors", timestamp: "2024-05-22" }
  ]},
  { id: 9, name: "Carbon County Enterprises", contact: "James Wilson", email: "jwilson@carbonent.com", phone: "(570) 555-9012", address: "369 Industry Ln, Jim Thorpe, PA", lat: 40.8759, lng: -75.7324, lathes: [{ type: "X19", quantity: 3 }], lastContact: "2023-08-30", notes: [
    { text: "Strategic partner", timestamp: "2023-08-30" }
  ]},
  { id: 10, name: "Bucks County Digital", contact: "Rachel Thompson", email: "rachel@bucksdigital.com", phone: "(215) 555-0123", address: "741 Route 611, Doylestown, PA", lat: 40.3101, lng: -75.1299, lathes: [{ type: "9.2", quantity: 2 }], lastContact: "2023-11-24", notes: [
    { text: "Budget approved for Q1", timestamp: "2023-11-24" }
  ]},
];

// Available lathe types
const LATHE_TYPES = ["9.0", "9.2", "X9", "X9d", "X15", "X19", "B17", "X1"];

// Status colors configuration
const STATUS_COLORS = {
  recent: { bg: '#10b981', light: '#d1fae5', border: '#059669' },
  '6 months': { bg: '#eab308', light: '#fef9c3', border: '#ca8a04' },
  '1 year': { bg: '#ef4444', light: '#fee2e2', border: '#dc2626' }
};

// Calculate status based on last contact date
const getStatusFromDate = (lastContactDate) => {
  const today = new Date();
  const lastContact = new Date(lastContactDate);
  const daysDiff = Math.floor((today - lastContact) / (1000 * 60 * 60 * 24));
  const monthsDiff = daysDiff / 30.44; // Average days per month
  
  if (monthsDiff < 6) {
    return 'recent';
  } else if (monthsDiff < 12) {
    return '6 months';
  } else {
    return '1 year';
  }
};

// Add calculated status to each customer
const customersWithStatus = DEMO_CUSTOMERS.map(customer => ({
  ...customer,
  status: getStatusFromDate(customer.lastContact)
}));

// Simple icon components to replace lucide-react
const MapPinIcon = ({ size = 20, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
    <circle cx="12" cy="10" r="3"></circle>
  </svg>
);

const SearchIcon = ({ size = 20, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="11" cy="11" r="8"></circle>
    <path d="m21 21-4.35-4.35"></path>
  </svg>
);

const PlusIcon = ({ size = 20, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="12" y1="5" x2="12" y2="19"></line>
    <line x1="5" y1="12" x2="19" y2="12"></line>
  </svg>
);

const XIcon = ({ size = 20, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18"></line>
    <line x1="6" y1="6" x2="18" y2="18"></line>
  </svg>
);

const MailIcon = ({ size = 20, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="4" width="20" height="16" rx="2"></rect>
    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>
  </svg>
);

const PhoneIcon = ({ size = 20, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
  </svg>
);

const CalendarIcon = ({ size = 20, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
    <line x1="16" y1="2" x2="16" y2="6"></line>
    <line x1="8" y1="2" x2="8" y2="6"></line>
    <line x1="3" y1="10" x2="21" y2="10"></line>
  </svg>
);

const UserIcon = ({ size = 20, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
    <circle cx="12" cy="7" r="4"></circle>
  </svg>
);

const EditIcon = ({ size = 20, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>
  </svg>
);

const TrashIcon = ({ size = 20, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="3 6 5 6 21 6"></polyline>
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
  </svg>
);

const MapCRM = () => {
  // Initialize from localStorage if available, otherwise use demo data
  const [customers, setCustomers] = useState(() => {
    const saved = localStorage.getItem('crm_customers');
    if (saved) {
      try {
        return JSON.parse(saved);
      } catch (e) {
        console.error('Error loading saved customers:', e);
        return customersWithStatus;
      }
    }
    return customersWithStatus;
  });
  
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [hoveredMarker, setHoveredMarker] = useState(null);
  const [leafletLoaded, setLeafletLoaded] = useState(false);
  const [newNote, setNewNote] = useState('');
  const [isEditing, setIsEditing] = useState(false);
  const [editedCustomer, setEditedCustomer] = useState(null);
  const [newLathe, setNewLathe] = useState({ type: "9.0", quantity: 1 });
  const [showAddForm, setShowAddForm] = useState(false);
  const [showImportModal, setShowImportModal] = useState(false);
  const [newCustomer, setNewCustomer] = useState({
    name: '',
    contact: '',
    email: '',
    phone: '',
    address: '',
    lat: 40.3,
    lng: -75.5,
    lathes: [],
    lastContact: new Date().toISOString().split('T')[0],
    notes: []
  });
  const mapRef = useRef(null);
  const mapInstanceRef = useRef(null);
  const markersRef = useRef({});

  // Save to localStorage whenever customers change
  useEffect(() => {
    localStorage.setItem('crm_customers', JSON.stringify(customers));
  }, [customers]);

  const filteredCustomers = customers.filter(customer => {
    const matchesSearch = customer.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         customer.contact.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         customer.address.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = statusFilter === 'all' || customer.status === statusFilter;
    return matchesSearch && matchesStatus;
  });

  const totalLathes = filteredCustomers.reduce((sum, c) => sum + (c.lathes?.reduce((s, l) => s + l.quantity, 0) || 0), 0);

  const handleDeleteCustomer = (customerId) => {
    if (window.confirm(`Delete ${selectedCustomer.name}?`)) {
      setCustomers(customers.filter(c => c.id !== customerId));
      setSelectedCustomer(null);
    }
  };

  const handleAddNote = () => {
    if (!newNote.trim()) return;
    
    const timestamp = new Date().toISOString().split('T')[0];
    const updatedCustomers = customers.map(c => 
      c.id === selectedCustomer.id 
        ? { ...c, notes: [{ text: newNote, timestamp }, ...(c.notes || [])] }
        : c
    );
    setCustomers(updatedCustomers);
    setSelectedCustomer({
      ...selectedCustomer,
      notes: [{ text: newNote, timestamp }, ...(selectedCustomer.notes || [])]
    });
    setNewNote('');
  };

  const handleEdit = () => {
    setIsEditing(true);
    setEditedCustomer({ ...selectedCustomer });
  };

  const handleSaveEdit = async () => {
    // Check if address has changed
    const originalCustomer = customers.find(c => c.id === editedCustomer.id);
    const addressChanged = originalCustomer && originalCustomer.address !== editedCustomer.address;
    
    let updatedCustomer = { ...editedCustomer };
    
    // If address changed, re-geocode it
    if (addressChanged && editedCustomer.address) {
      try {
        const response = await fetch(
          `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(editedCustomer.address)}`
        );
        const data = await response.json();
        
        if (data && data.length > 0) {
          updatedCustomer.lat = parseFloat(data[0].lat);
          updatedCustomer.lng = parseFloat(data[0].lon);
        } else {
          alert('Could not find location for the new address. Keeping original location. You can try editing again with a more specific address.');
        }
      } catch (error) {
        console.error('Geocoding error:', error);
        alert('Error geocoding new address. Keeping original location.');
      }
    }
    
    const updatedCustomers = customers.map(c => 
      c.id === updatedCustomer.id ? updatedCustomer : c
    );
    setCustomers(updatedCustomers);
    setSelectedCustomer(updatedCustomer);
    setIsEditing(false);
    setEditedCustomer(null);
  };

  const handleCancelEdit = () => {
    setIsEditing(false);
    setEditedCustomer(null);
  };

  const handleAddLathe = () => {
    if (!editedCustomer) return;
    setEditedCustomer({
      ...editedCustomer,
      lathes: [...(editedCustomer.lathes || []), { ...newLathe }]
    });
  };

  const handleRemoveLathe = (index) => {
    if (!editedCustomer) return;
    setEditedCustomer({
      ...editedCustomer,
      lathes: editedCustomer.lathes.filter((_, i) => i !== index)
    });
  };

  const handleAddCustomer = async () => {
    if (!newCustomer.name || !newCustomer.address) {
      alert('Please fill in at least Company Name and Address');
      return;
    }
    
    let lat = 40.3;
    let lng = -75.5;
    
    // Geocode the address if provided
    if (newCustomer.address) {
      try {
        const response = await fetch(
          `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(newCustomer.address)}`
        );
        const data = await response.json();
        
        if (data && data.length > 0) {
          lat = parseFloat(data[0].lat);
          lng = parseFloat(data[0].lon);
        } else {
          alert('Could not find location for this address. Using default location (center of Eastern PA). You can edit the customer later to adjust the location.');
        }
      } catch (error) {
        console.error('Geocoding error:', error);
        alert('Error finding address location. Using default location.');
      }
    }
    
    const customerToAdd = {
      ...newCustomer,
      id: Math.max(...customers.map(c => c.id), 0) + 1,
      lat: lat,
      lng: lng,
      status: getStatusFromDate(newCustomer.lastContact)
    };
    
    setCustomers([...customers, customerToAdd]);
    setShowAddForm(false);
    setNewCustomer({
      name: '',
      contact: '',
      email: '',
      phone: '',
      address: '',
      lat: 40.3,
      lng: -75.5,
      lathes: [],
      lastContact: new Date().toISOString().split('T')[0],
      notes: []
    });
    setNewLathe({ type: "9.0", quantity: 1 });
  };

  const handleCancelAdd = () => {
    setShowAddForm(false);
    setNewCustomer({
      name: '',
      contact: '',
      email: '',
      phone: '',
      address: '',
      lat: 40.3,
      lng: -75.5,
      lathes: [],
      lastContact: new Date().toISOString().split('T')[0],
      notes: []
    });
    setNewLathe({ type: "9.0", quantity: 1 });
  };

  const handleAddLatheToNew = () => {
    setNewCustomer({
      ...newCustomer,
      lathes: [...newCustomer.lathes, { ...newLathe }]
    });
  };

  const handleRemoveLatheFromNew = (index) => {
    setNewCustomer({
      ...newCustomer,
      lathes: newCustomer.lathes.filter((_, i) => i !== index)
    });
  };

  const handleClearAllData = () => {
    if (window.confirm('Are you sure you want to delete ALL customer data? This cannot be undone.')) {
      setCustomers([]);
      setSelectedCustomer(null);
      setIsEditing(false);
      setEditedCustomer(null);
      alert('All customer data has been cleared.');
    }
  };

  const handleImportCSV = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = async (e) => {
      try {
        const text = e.target.result;
        const lines = text.split('\n').filter(line => line.trim());
        
        // Helper function to parse CSV line with quoted fields
        const parseCSVLine = (line) => {
          const result = [];
          let current = '';
          let inQuotes = false;
          
          for (let i = 0; i < line.length; i++) {
            const char = line[i];
            
            if (char === '"') {
              inQuotes = !inQuotes;
            } else if (char === ',' && !inQuotes) {
              result.push(current.trim());
              current = '';
            } else {
              current += char;
            }
          }
          result.push(current.trim());
          return result;
        };
        
        const headers = parseCSVLine(lines[0]).map(h => h.toLowerCase());
        const importedCustomers = [];
        
        // Show progress
        alert(`Starting import of approximately ${lines.length - 1} customers. This will take about ${Math.ceil((lines.length - 1) / 60)} minutes due to geocoding. Please wait...`);
        
        for (let i = 1; i < lines.length; i++) {
          const line = lines[i].trim();
          if (!line) continue;
          
          const values = parseCSVLine(line);
          const customer = {};
          
          headers.forEach((header, index) => {
            customer[header] = values[index] ? values[index].replace(/^"|"$/g, '') : '';
          });
          
          // Required fields
          if (!customer.name || !customer.address) {
            console.warn(`Skipping row ${i + 1}: missing name or address`);
            continue;
          }
          
          // Geocode address if provided
          let lat = 40.3;
          let lng = -75.5;
          
          if (customer.address) {
            try {
              const response = await fetch(
                `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(customer.address)}`
              );
              const data = await response.json();
              
              if (data && data.length > 0) {
                lat = parseFloat(data[0].lat);
                lng = parseFloat(data[0].lon);
              }
              
              // Rate limit: wait 1 second between requests (Nominatim requirement)
              await new Promise(resolve => setTimeout(resolve, 1000));
              
              // Show progress every 10 customers
              if (i % 10 === 0) {
                console.log(`Imported ${i} of ${lines.length - 1} customers...`);
              }
            } catch (error) {
              console.error('Geocoding error for:', customer.address, error);
            }
          }
          
          // Parse lathes if provided (format: "9.0:2;X9:1" means 2 of 9.0 and 1 of X9)
          let lathes = [];
          if (customer.lathes) {
            const latheEntries = customer.lathes.split(';');
            lathes = latheEntries.map(entry => {
              const [type, quantity] = entry.split(':');
              return {
                type: type.trim(),
                quantity: parseInt(quantity) || 1
              };
            }).filter(l => LATHE_TYPES.includes(l.type));
          }
          
          importedCustomers.push({
            id: Math.max(...customers.map(c => c.id), 0, ...importedCustomers.map(c => c.id)) + 1,
            name: customer.name,
            contact: customer.contact || '',
            email: customer.email || '',
            phone: customer.phone || '',
            address: customer.address || '',
            lat: lat,
            lng: lng,
            lathes: lathes,
            lastContact: customer.lastcontact || new Date().toISOString().split('T')[0],
            status: getStatusFromDate(customer.lastcontact || new Date().toISOString().split('T')[0]),
            notes: customer.notes ? [{ text: customer.notes, timestamp: new Date().toISOString().split('T')[0] }] : []
          });
        }
        
        if (importedCustomers.length > 0) {
          setCustomers([...customers, ...importedCustomers]);
          setShowImportModal(false);
          alert(`Successfully imported ${importedCustomers.length} customers!`);
        } else {
          alert('No valid customers found in the file.');
        }
        
        // Reset file input
        event.target.value = '';
      } catch (error) {
        console.error('Import error:', error);
        alert('Error importing file. Please check the format and try again.');
      }
    };
    
    reader.readAsText(file);
  };

  const downloadSampleCSV = () => {
    const sampleCSV = `name,address,contact,email,phone,lathes,lastcontact,notes
Acme Manufacturing,"123 Main St, Philadelphia, PA",John Doe,john@acme.com,(555) 123-4567,9.0:2;X9:1,2024-12-01,Great customer
Tech Solutions Inc,"456 Market St, Allentown, PA",Jane Smith,jane@techsolutions.com,(555) 987-6543,X15:3,2024-06-15,Follow up needed`;
    
    const blob = new Blob([sampleCSV], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'sample_customer_import.csv';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  };

  const handleExportCSV = () => {
    // Create CSV content
    const headers = ['name', 'address', 'contact', 'email', 'phone', 'lathes', 'lastcontact', 'notes'];
    let csvContent = headers.join(',') + '\n';
    
    customers.forEach(customer => {
      const lathesStr = customer.lathes?.map(l => `${l.type}:${l.quantity}`).join(';') || '';
      const notesStr = customer.notes?.[0]?.text || '';
      
      const row = [
        customer.name,
        `"${customer.address}"`,
        customer.contact || '',
        customer.email || '',
        customer.phone || '',
        lathesStr,
        customer.lastContact || '',
        notesStr
      ];
      
      csvContent += row.join(',') + '\n';
    });
    
    // Download
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `customers_export_${new Date().toISOString().split('T')[0]}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
    
    alert(`Exported ${customers.length} customers to CSV!`);
  };

  // Load Leaflet library
  useEffect(() => {
    if (window.L) {
      setLeafletLoaded(true);
      return;
    }

    // Load Leaflet CSS
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
    link.integrity = 'sha256-p4NxAoJBhIIN+hmNHrzRCf9tD/miZyoHS5obTRR9BMY=';
    link.crossOrigin = '';
    document.head.appendChild(link);

    // Load Leaflet JS
    const script = document.createElement('script');
    script.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
    script.integrity = 'sha256-20nQCchB9co0qIjJZRGuk2/Z9VM+kNiyxNV1lvTlZBo=';
    script.crossOrigin = '';
    script.async = true;
    
    script.onload = () => {
      setLeafletLoaded(true);
    };
    
    script.onerror = () => {
      console.error('Failed to load Leaflet');
    };
    
    document.body.appendChild(script);

    return () => {
      // Cleanup if component unmounts before script loads
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);

  // Initialize map once Leaflet is loaded
  useEffect(() => {
    if (!leafletLoaded || !mapRef.current || mapInstanceRef.current) return;

    try {
      const L = window.L;
      
      // Create map centered on Eastern PA
      const map = L.map(mapRef.current, {
        center: [40.3, -75.5],
        zoom: 9,
        zoomControl: true
      });

      // Add OpenStreetMap tiles
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '© OpenStreetMap contributors',
        maxZoom: 18,
      }).addTo(map);

      mapInstanceRef.current = map;
    } catch (error) {
      console.error('Error initializing map:', error);
    }

    return () => {
      if (mapInstanceRef.current) {
        try {
          mapInstanceRef.current.remove();
        } catch (error) {
          console.error('Error removing map:', error);
        }
        mapInstanceRef.current = null;
      }
    };
  }, [leafletLoaded]);

  // Update markers when customers change
  useEffect(() => {
    if (!mapInstanceRef.current || !window.L || !leafletLoaded) return;

    try {
      const L = window.L;
      
      // Remove old markers
      Object.values(markersRef.current).forEach(marker => {
        try {
          marker.remove();
        } catch (e) {
          // Ignore errors removing markers
        }
      });
      markersRef.current = {};

      // Add new markers
      filteredCustomers.forEach(customer => {
        const isSelected = selectedCustomer?.id === customer.id;
        const isHovered = hoveredMarker === customer.id;
        const color = isSelected ? '#06b6d4' : STATUS_COLORS[customer.status].bg;
        const size = isSelected || isHovered ? 16 : 12;

        // Custom icon
        const icon = L.divIcon({
          className: 'custom-marker',
          html: `
            <div style="
              width: ${size * 2}px;
              height: ${size * 2}px;
              background: ${color};
              border: 3px solid white;
              border-radius: 50%;
              box-shadow: 0 4px 12px rgba(0,0,0,0.3);
              display: flex;
              align-items: center;
              justify-content: center;
              cursor: pointer;
              transition: all 0.3s;
              ${customer.status === '1 year' ? 'animation: pulse-marker 2s infinite;' : ''}
            ">
              <svg width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2">
                <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                <line x1="9" y1="3" x2="9" y2="21"></line>
              </svg>
            </div>
          `,
          iconSize: [size * 2, size * 2],
          iconAnchor: [size, size],
        });

        const marker = L.marker([customer.lat, customer.lng], { icon })
          .addTo(mapInstanceRef.current);

        // Bind popup
        marker.bindPopup(`
          <div style="font-family: 'Manrope', sans-serif;">
            <strong style="font-size: 14px; color: #0f172a;">${customer.name}</strong><br/>
            <span style="font-size: 12px; color: #64748b;">
              ${customer.lathes?.reduce((sum, l) => sum + l.quantity, 0) || 0} ${customer.lathes?.reduce((sum, l) => sum + l.quantity, 0) === 1 ? 'lathe' : 'lathes'} · ${customer.status}
            </span>
          </div>
        `);

        // Click event
        marker.on('click', () => {
          setSelectedCustomer(customer);
        });

        // Hover events
        marker.on('mouseover', () => {
          setHoveredMarker(customer.id);
          marker.openPopup();
        });

        marker.on('mouseout', () => {
          setHoveredMarker(null);
          if (selectedCustomer?.id !== customer.id) {
            marker.closePopup();
          }
        });

        markersRef.current[customer.id] = marker;
      });
    } catch (error) {
      console.error('Error updating markers:', error);
    }
  }, [leafletLoaded, filteredCustomers, selectedCustomer, hoveredMarker]);

  // Pan to customer when selected
  useEffect(() => {
    if (selectedCustomer && mapInstanceRef.current) {
      mapInstanceRef.current.setView([selectedCustomer.lat, selectedCustomer.lng], 12, {
        animate: true
      });
    }
  }, [selectedCustomer]);

  return (
    <div style={{
      width: '100vw',
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
      fontFamily: "'Manrope', -apple-system, sans-serif",
      color: '#f1f5f9',
      overflow: 'hidden'
    }}>
      {/* Header */}
      <header style={{
        background: 'rgba(15, 23, 42, 0.8)',
        backdropFilter: 'blur(12px)',
        borderBottom: '1px solid rgba(148, 163, 184, 0.1)',
        padding: '16px 24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexShrink: 0,
        boxShadow: '0 4px 24px rgba(0, 0, 0, 0.3)'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <div style={{
            width: '40px',
            height: '40px',
            background: 'linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)',
            borderRadius: '10px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 4px 12px rgba(6, 182, 212, 0.4)'
          }}>
            <MapPinIcon size={22} color="#fff" />
          </div>
          <div>
            <h1 style={{ 
              margin: 0, 
              fontSize: '22px', 
              fontWeight: 800,
              letterSpacing: '-0.5px',
              background: 'linear-gradient(135deg, #ffffff 0%, #cbd5e1 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent'
            }}>
              MapCRM
            </h1>
            <p style={{ margin: 0, fontSize: '12px', color: '#94a3b8', fontWeight: 500 }}>
              {filteredCustomers.length} customers · {totalLathes} lathes on-site
            </p>
          </div>
        </div>
        
        <div style={{ display: 'flex', gap: '12px' }}>
          <button
            onClick={handleExportCSV}
            style={{
              background: 'rgba(16, 185, 129, 0.1)',
              border: '1px solid rgba(16, 185, 129, 0.3)',
              borderRadius: '10px',
              padding: '10px 20px',
              color: '#10b981',
              fontWeight: 700,
              fontSize: '14px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              transition: 'all 0.2s'
            }}
            onMouseOver={e => e.currentTarget.style.background = 'rgba(16, 185, 129, 0.2)'}
            onMouseOut={e => e.currentTarget.style.background = 'rgba(16, 185, 129, 0.1)'}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
              <polyline points="7 10 12 15 17 10"></polyline>
              <line x1="12" y1="15" x2="12" y2="3"></line>
            </svg>
            Export CSV
          </button>
          
          <button
            onClick={() => setShowImportModal(true)}
            style={{
              background: 'rgba(6, 182, 212, 0.1)',
              border: '1px solid rgba(6, 182, 212, 0.3)',
              borderRadius: '10px',
              padding: '10px 20px',
              color: '#06b6d4',
              fontWeight: 700,
              fontSize: '14px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              transition: 'all 0.2s'
            }}
            onMouseOver={e => e.currentTarget.style.background = 'rgba(6, 182, 212, 0.2)'}
            onMouseOut={e => e.currentTarget.style.background = 'rgba(6, 182, 212, 0.1)'}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
              <polyline points="17 8 12 3 7 8"></polyline>
              <line x1="12" y1="3" x2="12" y2="15"></line>
            </svg>
            Import CSV
          </button>
          
          <button
            onClick={handleClearAllData}
            style={{
              background: 'rgba(239, 68, 68, 0.1)',
              border: '1px solid rgba(239, 68, 68, 0.3)',
              borderRadius: '10px',
              padding: '10px 20px',
              color: '#ef4444',
              fontWeight: 700,
              fontSize: '14px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              transition: 'all 0.2s'
            }}
            onMouseOver={e => e.currentTarget.style.background = 'rgba(239, 68, 68, 0.2)'}
            onMouseOut={e => e.currentTarget.style.background = 'rgba(239, 68, 68, 0.1)'}
          >
            <TrashIcon size={18} color="#ef4444" />
            Clear All
          </button>
          
          <button
            onClick={() => setShowAddForm(true)}
            style={{
              background: 'linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)',
              border: 'none',
              borderRadius: '10px',
              padding: '10px 20px',
              color: '#fff',
              fontWeight: 700,
              fontSize: '14px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              boxShadow: '0 4px 12px rgba(6, 182, 212, 0.4)',
              transition: 'all 0.2s'
            }}
            onMouseOver={e => e.currentTarget.style.transform = 'translateY(-1px)'}
            onMouseOut={e => e.currentTarget.style.transform = 'translateY(0)'}
          >
            <PlusIcon size={18} color="#fff" />
            Add Customer
          </button>
        </div>
      </header>

      {/* Import Modal */}
      {showImportModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.7)',
          backdropFilter: 'blur(4px)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 2000,
          animation: 'fadeIn 0.2s ease-out'
        }}>
          <div style={{
            width: '500px',
            background: 'rgba(15, 23, 42, 0.98)',
            backdropFilter: 'blur(12px)',
            border: '1px solid rgba(6, 182, 212, 0.3)',
            borderRadius: '16px',
            padding: '24px',
            boxShadow: '0 20px 60px rgba(0, 0, 0, 0.8)'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <h2 style={{ margin: 0, fontSize: '22px', fontWeight: 800, color: '#f1f5f9' }}>
                Import Customers from CSV
              </h2>
              <button
                onClick={() => setShowImportModal(false)}
                style={{
                  background: 'transparent',
                  border: 'none',
                  color: '#94a3b8',
                  cursor: 'pointer',
                  padding: '4px'
                }}
              >
                <XIcon size={24} />
              </button>
            </div>

            <div style={{ marginBottom: '24px' }}>
              <p style={{ color: '#cbd5e1', fontSize: '14px', lineHeight: 1.6, marginBottom: '16px' }}>
                Upload a CSV file with customer information. Your CSV should include these columns:
              </p>
              <ul style={{ color: '#94a3b8', fontSize: '13px', lineHeight: 1.8, paddingLeft: '20px' }}>
                <li><strong style={{ color: '#06b6d4' }}>name</strong> - Company name (required)</li>
                <li><strong style={{ color: '#06b6d4' }}>address</strong> - Full address (required, will be geocoded)</li>
                <li><strong style={{ color: '#94a3b8' }}>contact</strong> - Contact person name (optional)</li>
                <li><strong style={{ color: '#94a3b8' }}>email</strong> - Email address (optional)</li>
                <li><strong style={{ color: '#94a3b8' }}>phone</strong> - Phone number (optional)</li>
                <li><strong style={{ color: '#94a3b8' }}>lathes</strong> - Format: "9.0:2;X9:1" (optional)</li>
                <li><strong style={{ color: '#94a3b8' }}>lastcontact</strong> - Date in YYYY-MM-DD format (optional)</li>
                <li><strong style={{ color: '#94a3b8' }}>notes</strong> - Any notes (optional)</li>
              </ul>
              
              <button
                onClick={downloadSampleCSV}
                style={{
                  marginTop: '16px',
                  padding: '8px 16px',
                  background: 'rgba(6, 182, 212, 0.1)',
                  border: '1px solid rgba(6, 182, 212, 0.3)',
                  borderRadius: '8px',
                  color: '#06b6d4',
                  fontSize: '13px',
                  fontWeight: 600,
                  cursor: 'pointer'
                }}
              >
                Download Sample CSV
              </button>
            </div>

            <div style={{ 
              padding: '24px',
              background: 'rgba(6, 182, 212, 0.05)',
              border: '2px dashed rgba(6, 182, 212, 0.3)',
              borderRadius: '12px',
              textAlign: 'center'
            }}>
              <input
                type="file"
                accept=".csv"
                onChange={handleImportCSV}
                style={{ display: 'none' }}
                id="csv-upload"
              />
              <label
                htmlFor="csv-upload"
                style={{
                  display: 'inline-block',
                  padding: '12px 24px',
                  background: 'linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)',
                  border: 'none',
                  borderRadius: '10px',
                  color: '#fff',
                  fontSize: '14px',
                  fontWeight: 700,
                  cursor: 'pointer',
                  boxShadow: '0 4px 12px rgba(6, 182, 212, 0.4)'
                }}
              >
                Choose CSV File
              </label>
              <p style={{ color: '#64748b', fontSize: '12px', marginTop: '12px' }}>
                Addresses will be automatically geocoded to place markers on the map
              </p>
            </div>
          </div>
        </div>
      )}

      {/* Add Customer Modal */}
      {showAddForm && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.7)',
          backdropFilter: 'blur(4px)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 2000,
          animation: 'fadeIn 0.2s ease-out'
        }}>
          <div style={{
            width: '500px',
            maxHeight: '90vh',
            overflowY: 'auto',
            background: 'rgba(15, 23, 42, 0.98)',
            backdropFilter: 'blur(12px)',
            border: '1px solid rgba(6, 182, 212, 0.3)',
            borderRadius: '16px',
            padding: '24px',
            boxShadow: '0 20px 60px rgba(0, 0, 0, 0.8)',
            animation: 'slideInRight 0.3s ease-out'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
              <h2 style={{ margin: 0, fontSize: '22px', fontWeight: 800, color: '#f1f5f9' }}>
                Add New Customer
              </h2>
              <button
                onClick={handleCancelAdd}
                style={{
                  background: 'transparent',
                  border: 'none',
                  color: '#94a3b8',
                  cursor: 'pointer',
                  padding: '4px'
                }}
              >
                <XIcon size={24} />
              </button>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              {/* Company Name */}
              <div>
                <label style={{ display: 'block', fontSize: '12px', color: '#64748b', fontWeight: 600, marginBottom: '8px' }}>
                  COMPANY NAME *
                </label>
                <input
                  type="text"
                  value={newCustomer.name}
                  onChange={(e) => setNewCustomer({ ...newCustomer, name: e.target.value })}
                  placeholder="Enter company name"
                  style={{
                    width: '100%',
                    padding: '10px 12px',
                    background: 'rgba(15, 23, 42, 0.6)',
                    border: '1px solid rgba(148, 163, 184, 0.2)',
                    borderRadius: '8px',
                    color: '#f1f5f9',
                    fontSize: '14px',
                    outline: 'none',
                    fontFamily: "'Manrope', -apple-system, sans-serif"
                  }}
                  onFocus={(e) => e.target.style.borderColor = '#06b6d4'}
                  onBlur={(e) => e.target.style.borderColor = 'rgba(148, 163, 184, 0.2)'}
                />
              </div>

              {/* Contact Name */}
              <div>
                <label style={{ display: 'block', fontSize: '12px', color: '#64748b', fontWeight: 600, marginBottom: '8px' }}>
                  CONTACT NAME
                </label>
                <input
                  type="text"
                  value={newCustomer.contact}
                  onChange={(e) => setNewCustomer({ ...newCustomer, contact: e.target.value })}
                  placeholder="Enter contact name"
                  style={{
                    width: '100%',
                    padding: '10px 12px',
                    background: 'rgba(15, 23, 42, 0.6)',
                    border: '1px solid rgba(148, 163, 184, 0.2)',
                    borderRadius: '8px',
                    color: '#f1f5f9',
                    fontSize: '14px',
                    outline: 'none',
                    fontFamily: "'Manrope', -apple-system, sans-serif"
                  }}
                  onFocus={(e) => e.target.style.borderColor = '#06b6d4'}
                  onBlur={(e) => e.target.style.borderColor = 'rgba(148, 163, 184, 0.2)'}
                />
              </div>

              {/* Email */}
              <div>
                <label style={{ display: 'block', fontSize: '12px', color: '#64748b', fontWeight: 600, marginBottom: '8px' }}>
                  EMAIL
                </label>
                <input
                  type="email"
                  value={newCustomer.email}
                  onChange={(e) => setNewCustomer({ ...newCustomer, email: e.target.value })}
                  placeholder="Enter email"
                  style={{
                    width: '100%',
                    padding: '10px 12px',
                    background: 'rgba(15, 23, 42, 0.6)',
                    border: '1px solid rgba(148, 163, 184, 0.2)',
                    borderRadius: '8px',
                    color: '#f1f5f9',
                    fontSize: '14px',
                    outline: 'none',
                    fontFamily: "'Manrope', -apple-system, sans-serif"
                  }}
                  onFocus={(e) => e.target.style.borderColor = '#06b6d4'}
                  onBlur={(e) => e.target.style.borderColor = 'rgba(148, 163, 184, 0.2)'}
                />
              </div>

              {/* Phone */}
              <div>
                <label style={{ display: 'block', fontSize: '12px', color: '#64748b', fontWeight: 600, marginBottom: '8px' }}>
                  PHONE
                </label>
                <input
                  type="tel"
                  value={newCustomer.phone}
                  onChange={(e) => setNewCustomer({ ...newCustomer, phone: e.target.value })}
                  placeholder="Enter phone number"
                  style={{
                    width: '100%',
                    padding: '10px 12px',
                    background: 'rgba(15, 23, 42, 0.6)',
                    border: '1px solid rgba(148, 163, 184, 0.2)',
                    borderRadius: '8px',
                    color: '#f1f5f9',
                    fontSize: '14px',
                    outline: 'none',
                    fontFamily: "'Manrope', -apple-system, sans-serif"
                  }}
                  onFocus={(e) => e.target.style.borderColor = '#06b6d4'}
                  onBlur={(e) => e.target.style.borderColor = 'rgba(148, 163, 184, 0.2)'}
                />
              </div>

              {/* Address */}
              <div>
                <label style={{ display: 'block', fontSize: '12px', color: '#64748b', fontWeight: 600, marginBottom: '8px' }}>
                  ADDRESS *
                </label>
                <input
                  type="text"
                  value={newCustomer.address}
                  onChange={(e) => setNewCustomer({ ...newCustomer, address: e.target.value })}
                  placeholder="Enter address"
                  style={{
                    width: '100%',
                    padding: '10px 12px',
                    background: 'rgba(15, 23, 42, 0.6)',
                    border: '1px solid rgba(148, 163, 184, 0.2)',
                    borderRadius: '8px',
                    color: '#f1f5f9',
                    fontSize: '14px',
                    outline: 'none',
                    fontFamily: "'Manrope', -apple-system, sans-serif"
                  }}
                  onFocus={(e) => e.target.style.borderColor = '#06b6d4'}
                  onBlur={(e) => e.target.style.borderColor = 'rgba(148, 163, 184, 0.2)'}
                />
              </div>

              {/* Lathes */}
              <div>
                <label style={{ display: 'block', fontSize: '12px', color: '#64748b', fontWeight: 600, marginBottom: '8px' }}>
                  LATHES ON-SITE
                </label>
                
                {/* Existing Lathes */}
                {newCustomer.lathes && newCustomer.lathes.length > 0 && (
                  <div style={{ marginBottom: '12px' }}>
                    {newCustomer.lathes.map((lathe, index) => (
                      <div key={index} style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        marginBottom: '8px',
                        padding: '8px',
                        background: 'rgba(6, 182, 212, 0.05)',
                        borderRadius: '8px',
                        border: '1px solid rgba(6, 182, 212, 0.1)'
                      }}>
                        <span style={{ flex: 1, fontSize: '14px', color: '#f1f5f9', fontWeight: 600 }}>
                          {lathe.type}
                        </span>
                        <span style={{ fontSize: '14px', color: '#cbd5e1' }}>
                          × {lathe.quantity}
                        </span>
                        <button
                          onClick={() => handleRemoveLatheFromNew(index)}
                          style={{
                            background: 'rgba(239, 68, 68, 0.1)',
                            border: '1px solid rgba(239, 68, 68, 0.3)',
                            borderRadius: '6px',
                            padding: '4px 8px',
                            color: '#ef4444',
                            fontSize: '11px',
                            cursor: 'pointer',
                            fontWeight: 600
                          }}
                        >
                          Remove
                        </button>
                      </div>
                    ))}
                  </div>
                )}
                
                {/* Add New Lathe */}
                <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                  <select
                    value={newLathe.type}
                    onChange={(e) => setNewLathe({ ...newLathe, type: e.target.value })}
                    style={{
                      flex: 1,
                      padding: '8px 12px',
                      background: 'rgba(15, 23, 42, 0.6)',
                      border: '1px solid rgba(148, 163, 184, 0.2)',
                      borderRadius: '8px',
                      color: '#f1f5f9',
                      fontSize: '14px',
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: "'Manrope', -apple-system, sans-serif"
                    }}
                  >
                    {LATHE_TYPES.map(type => (
                      <option key={type} value={type}>{type}</option>
                    ))}
                  </select>
                  
                  <select
                    value={newLathe.quantity}
                    onChange={(e) => setNewLathe({ ...newLathe, quantity: parseInt(e.target.value) })}
                    style={{
                      width: '70px',
                      padding: '8px 12px',
                      background: 'rgba(15, 23, 42, 0.6)',
                      border: '1px solid rgba(148, 163, 184, 0.2)',
                      borderRadius: '8px',
                      color: '#f1f5f9',
                      fontSize: '14px',
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: "'Manrope', -apple-system, sans-serif"
                    }}
                  >
                    {Array.from({ length: 20 }, (_, i) => i + 1).map(num => (
                      <option key={num} value={num}>{num}</option>
                    ))}
                  </select>
                  
                  <button
                    onClick={handleAddLatheToNew}
                    style={{
                      padding: '8px 12px',
                      background: 'linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)',
                      border: 'none',
                      borderRadius: '8px',
                      color: '#fff',
                      fontSize: '12px',
                      fontWeight: 600,
                      cursor: 'pointer',
                      whiteSpace: 'nowrap'
                    }}
                  >
                    Add
                  </button>
                </div>
              </div>
            </div>

            {/* Action Buttons */}
            <div style={{ display: 'flex', gap: '12px', marginTop: '24px', paddingTop: '20px', borderTop: '1px solid rgba(148, 163, 184, 0.1)' }}>
              <button
                onClick={handleAddCustomer}
                style={{
                  flex: 1,
                  padding: '12px',
                  background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                  border: 'none',
                  borderRadius: '10px',
                  color: '#fff',
                  fontSize: '14px',
                  fontWeight: 700,
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px'
                }}
              >
                <PlusIcon size={16} color="#fff" />
                Add Customer
              </button>
              <button
                onClick={handleCancelAdd}
                style={{
                  flex: 1,
                  padding: '12px',
                  background: 'rgba(148, 163, 184, 0.1)',
                  border: '1px solid rgba(148, 163, 184, 0.3)',
                  borderRadius: '10px',
                  color: '#cbd5e1',
                  fontSize: '14px',
                  fontWeight: 700,
                  cursor: 'pointer'
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Main Content */}
      <div style={{ display: 'flex', flex: 1, overflow: 'hidden' }}>
        {/* Sidebar */}
        <div style={{
          width: '380px',
          background: 'rgba(30, 41, 59, 0.6)',
          backdropFilter: 'blur(12px)',
          borderRight: '1px solid rgba(148, 163, 184, 0.1)',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden'
        }}>
          {/* Search and Filters */}
          <div style={{ padding: '20px', borderBottom: '1px solid rgba(148, 163, 184, 0.1)' }}>
            <div style={{
              position: 'relative',
              marginBottom: '12px'
            }}>
              <div style={{
                position: 'absolute',
                left: '14px',
                top: '50%',
                transform: 'translateY(-50%)',
                display: 'flex',
                alignItems: 'center'
              }}>
                <SearchIcon size={18} color="#64748b" />
              </div>
              <input
                type="text"
                placeholder="Search customers..."
                value={searchTerm}
                onChange={e => setSearchTerm(e.target.value)}
                style={{
                  width: '100%',
                  padding: '12px 12px 12px 44px',
                  background: 'rgba(15, 23, 42, 0.6)',
                  border: '1px solid rgba(148, 163, 184, 0.2)',
                  borderRadius: '10px',
                  color: '#f1f5f9',
                  fontSize: '14px',
                  outline: 'none',
                  transition: 'all 0.2s'
                }}
                onFocus={e => e.target.style.borderColor = '#06b6d4'}
                onBlur={e => e.target.style.borderColor = 'rgba(148, 163, 184, 0.2)'}
              />
            </div>

            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
              {['all', 'recent', '6 months', '1 year'].map(status => (
                <button
                  key={status}
                  onClick={() => setStatusFilter(status)}
                  style={{
                    padding: '6px 14px',
                    background: statusFilter === status 
                      ? (status === 'all' ? '#06b6d4' : STATUS_COLORS[status]?.bg || '#06b6d4')
                      : 'rgba(15, 23, 42, 0.6)',
                    border: `1px solid ${statusFilter === status 
                      ? (status === 'all' ? '#0891b2' : STATUS_COLORS[status]?.border || '#0891b2')
                      : 'rgba(148, 163, 184, 0.2)'}`,
                    borderRadius: '8px',
                    color: statusFilter === status ? '#fff' : '#cbd5e1',
                    fontSize: '12px',
                    fontWeight: 600,
                    cursor: 'pointer',
                    textTransform: 'capitalize',
                    transition: 'all 0.2s'
                  }}
                >
                  {status}
                </button>
              ))}
            </div>
          </div>

          {/* Customer List */}
          <div style={{ flex: 1, overflowY: 'auto', padding: '8px' }}>
            {filteredCustomers.map((customer, idx) => (
              <div
                key={customer.id}
                onClick={() => setSelectedCustomer(customer)}
                onMouseEnter={() => setHoveredMarker(customer.id)}
                onMouseLeave={() => setHoveredMarker(null)}
                style={{
                  background: selectedCustomer?.id === customer.id 
                    ? 'rgba(6, 182, 212, 0.15)' 
                    : hoveredMarker === customer.id
                    ? 'rgba(148, 163, 184, 0.1)'
                    : 'transparent',
                  border: `1px solid ${selectedCustomer?.id === customer.id ? '#06b6d4' : 'rgba(148, 163, 184, 0.1)'}`,
                  borderRadius: '12px',
                  padding: '14px',
                  marginBottom: '8px',
                  cursor: 'pointer',
                  transition: 'all 0.2s',
                  animation: `slideIn 0.3s ease-out ${idx * 0.05}s backwards`
                }}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px' }}>
                  <div>
                    <h3 style={{ 
                      margin: '0 0 4px 0', 
                      fontSize: '15px', 
                      fontWeight: 700,
                      color: '#f1f5f9'
                    }}>
                      {customer.name}
                    </h3>
                    <p style={{ 
                      margin: 0, 
                      fontSize: '13px', 
                      color: '#94a3b8',
                      fontWeight: 500
                    }}>
                      {customer.contact}
                    </p>
                  </div>
                  <span style={{
                    padding: '4px 10px',
                    background: STATUS_COLORS[customer.status].light,
                    color: STATUS_COLORS[customer.status].border,
                    borderRadius: '6px',
                    fontSize: '11px',
                    fontWeight: 700,
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px'
                  }}>
                    {customer.status}
                  </span>
                </div>
                
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '6px' }}>
                  <MapPinIcon size={14} color="#64748b" />
                  <span style={{ fontSize: '12px', color: '#cbd5e1' }}>{customer.address}</span>
                </div>
                
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#10b981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <rect x="2" y="4" width="20" height="16" rx="2"/>
                      <circle cx="8" cy="12" r="2"/>
                      <circle cx="16" cy="12" r="2"/>
                    </svg>
                    <span style={{ fontSize: '14px', fontWeight: 700, color: '#10b981' }}>
                      {customer.lathes?.reduce((sum, l) => sum + l.quantity, 0) || 0} {customer.lathes?.reduce((sum, l) => sum + l.quantity, 0) === 1 ? 'lathe' : 'lathes'}
                    </span>
                  </div>
                  <span style={{ fontSize: '11px', color: '#64748b' }}>
                    {customer.lastContact}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Map Area */}
        <div style={{ flex: 1, position: 'relative', background: '#1e293b' }}>
          {/* Loading indicator */}
          {!leafletLoaded && (
            <div style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              textAlign: 'center',
              zIndex: 1000
            }}>
              <div style={{
                width: '50px',
                height: '50px',
                border: '4px solid rgba(6, 182, 212, 0.2)',
                borderTopColor: '#06b6d4',
                borderRadius: '50%',
                animation: 'spin 1s linear infinite',
                margin: '0 auto 16px'
              }}/>
              <div style={{ color: '#94a3b8', fontSize: '14px', fontWeight: 600 }}>
                Loading map...
              </div>
            </div>
          )}
          
          {/* Leaflet Map Container */}
          <div 
            ref={mapRef}
            style={{
              width: '100%',
              height: '100%',
              position: 'relative',
              zIndex: 1,
              opacity: leafletLoaded ? 1 : 0,
              transition: 'opacity 0.3s'
            }}
          />

          {/* Customer Detail Panel */}
          {selectedCustomer && (
            <div style={{
              position: 'absolute',
              top: '20px',
              right: '20px',
              width: '360px',
              background: 'rgba(15, 23, 42, 0.95)',
              backdropFilter: 'blur(12px)',
              border: '1px solid rgba(6, 182, 212, 0.3)',
              borderRadius: '16px',
              padding: '24px',
              boxShadow: '0 12px 48px rgba(0, 0, 0, 0.5)',
              animation: 'slideInRight 0.3s ease-out',
              zIndex: 1000
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '20px' }}>
                <div style={{ flex: 1 }}>
                  {isEditing ? (
                    <input
                      type="text"
                      value={editedCustomer.name}
                      onChange={(e) => setEditedCustomer({ ...editedCustomer, name: e.target.value })}
                      style={{
                        width: '100%',
                        margin: '0 0 8px 0',
                        fontSize: '20px',
                        fontWeight: 800,
                        padding: '8px',
                        background: 'rgba(15, 23, 42, 0.6)',
                        border: '1px solid rgba(148, 163, 184, 0.2)',
                        borderRadius: '8px',
                        color: '#f1f5f9',
                        outline: 'none',
                        fontFamily: "'Manrope', -apple-system, sans-serif"
                      }}
                      onFocus={(e) => e.target.style.borderColor = '#06b6d4'}
                      onBlur={(e) => e.target.style.borderColor = 'rgba(148, 163, 184, 0.2)'}
                    />
                  ) : (
                    <h2 style={{ margin: '0 0 8px 0', fontSize: '20px', fontWeight: 800 }}>
                      {selectedCustomer.name}
                    </h2>
                  )}
                  <span style={{
                    padding: '4px 12px',
                    background: STATUS_COLORS[selectedCustomer.status].light,
                    color: STATUS_COLORS[selectedCustomer.status].border,
                    borderRadius: '6px',
                    fontSize: '11px',
                    fontWeight: 700,
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px'
                  }}>
                    {selectedCustomer.status}
                  </span>
                </div>
                <button
                  onClick={() => {
                    setSelectedCustomer(null);
                    setIsEditing(false);
                    setEditedCustomer(null);
                  }}
                  style={{
                    background: 'transparent',
                    border: 'none',
                    color: '#94a3b8',
                    cursor: 'pointer',
                    padding: '4px',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  <XIcon size={20} />
                </button>
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                <div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                    <UserIcon size={16} color="#06b6d4" />
                    <span style={{ fontSize: '12px', color: '#64748b', fontWeight: 600 }}>CONTACT</span>
                  </div>
                  {isEditing ? (
                    <input
                      type="text"
                      value={editedCustomer.contact}
                      onChange={(e) => setEditedCustomer({ ...editedCustomer, contact: e.target.value })}
                      style={{
                        width: '100%',
                        padding: '8px 12px',
                        background: 'rgba(15, 23, 42, 0.6)',
                        border: '1px solid rgba(148, 163, 184, 0.2)',
                        borderRadius: '8px',
                        color: '#f1f5f9',
                        fontSize: '14px',
                        fontWeight: 600,
                        outline: 'none',
                        fontFamily: "'Manrope', -apple-system, sans-serif"
                      }}
                      onFocus={(e) => e.target.style.borderColor = '#06b6d4'}
                      onBlur={(e) => e.target.style.borderColor = 'rgba(148, 163, 184, 0.2)'}
                    />
                  ) : (
                    <div style={{ fontSize: '14px', color: '#f1f5f9', fontWeight: 600 }}>
                      {selectedCustomer.contact}
                    </div>
                  )}
                </div>

                <div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                    <MailIcon size={16} color="#06b6d4" />
                    <span style={{ fontSize: '12px', color: '#64748b', fontWeight: 600 }}>EMAIL</span>
                  </div>
                  {isEditing ? (
                    <input
                      type="email"
                      value={editedCustomer.email}
                      onChange={(e) => setEditedCustomer({ ...editedCustomer, email: e.target.value })}
                      style={{
                        width: '100%',
                        padding: '8px 12px',
                        background: 'rgba(15, 23, 42, 0.6)',
                        border: '1px solid rgba(148, 163, 184, 0.2)',
                        borderRadius: '8px',
                        color: '#f1f5f9',
                        fontSize: '14px',
                        fontWeight: 500,
                        outline: 'none',
                        fontFamily: "'Manrope', -apple-system, sans-serif"
                      }}
                      onFocus={(e) => e.target.style.borderColor = '#06b6d4'}
                      onBlur={(e) => e.target.style.borderColor = 'rgba(148, 163, 184, 0.2)'}
                    />
                  ) : (
                    <a href={`mailto:${selectedCustomer.email}`} style={{ 
                      fontSize: '14px', 
                      color: '#06b6d4',
                      textDecoration: 'none',
                      fontWeight: 500
                    }}>
                      {selectedCustomer.email}
                    </a>
                  )}
                </div>

                <div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                    <PhoneIcon size={16} color="#06b6d4" />
                    <span style={{ fontSize: '12px', color: '#64748b', fontWeight: 600 }}>PHONE</span>
                  </div>
                  {isEditing ? (
                    <input
                      type="tel"
                      value={editedCustomer.phone}
                      onChange={(e) => setEditedCustomer({ ...editedCustomer, phone: e.target.value })}
                      style={{
                        width: '100%',
                        padding: '8px 12px',
                        background: 'rgba(15, 23, 42, 0.6)',
                        border: '1px solid rgba(148, 163, 184, 0.2)',
                        borderRadius: '8px',
                        color: '#f1f5f9',
                        fontSize: '14px',
                        fontWeight: 500,
                        outline: 'none',
                        fontFamily: "'Manrope', -apple-system, sans-serif"
                      }}
                      onFocus={(e) => e.target.style.borderColor = '#06b6d4'}
                      onBlur={(e) => e.target.style.borderColor = 'rgba(148, 163, 184, 0.2)'}
                    />
                  ) : (
                    <a href={`tel:${selectedCustomer.phone}`} style={{ 
                      fontSize: '14px', 
                      color: '#06b6d4',
                      textDecoration: 'none',
                      fontWeight: 500
                    }}>
                      {selectedCustomer.phone}
                    </a>
                  )}
                </div>

                <div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                    <MapPinIcon size={16} color="#06b6d4" />
                    <span style={{ fontSize: '12px', color: '#64748b', fontWeight: 600 }}>ADDRESS</span>
                  </div>
                  {isEditing ? (
                    <input
                      type="text"
                      value={editedCustomer.address}
                      onChange={(e) => setEditedCustomer({ ...editedCustomer, address: e.target.value })}
                      style={{
                        width: '100%',
                        padding: '8px 12px',
                        background: 'rgba(15, 23, 42, 0.6)',
                        border: '1px solid rgba(148, 163, 184, 0.2)',
                        borderRadius: '8px',
                        color: '#f1f5f9',
                        fontSize: '14px',
                        outline: 'none',
                        fontFamily: "'Manrope', -apple-system, sans-serif"
                      }}
                      onFocus={(e) => e.target.style.borderColor = '#06b6d4'}
                      onBlur={(e) => e.target.style.borderColor = 'rgba(148, 163, 184, 0.2)'}
                    />
                  ) : (
                    <div style={{ fontSize: '14px', color: '#cbd5e1', lineHeight: 1.5 }}>
                      {selectedCustomer.address}
                    </div>
                  )}
                </div>

                <div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#06b6d4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <rect x="2" y="4" width="20" height="16" rx="2"/>
                      <circle cx="8" cy="12" r="2"/>
                      <circle cx="16" cy="12" r="2"/>
                    </svg>
                    <span style={{ fontSize: '12px', color: '#64748b', fontWeight: 600 }}>LATHES ON-SITE</span>
                  </div>
                  
                  {isEditing ? (
                    <div>
                      {/* Existing Lathes */}
                      <div style={{ marginBottom: '12px' }}>
                        {editedCustomer.lathes && editedCustomer.lathes.length > 0 ? (
                          editedCustomer.lathes.map((lathe, index) => (
                            <div key={index} style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '8px',
                              marginBottom: '8px',
                              padding: '8px',
                              background: 'rgba(6, 182, 212, 0.05)',
                              borderRadius: '8px',
                              border: '1px solid rgba(6, 182, 212, 0.1)'
                            }}>
                              <span style={{ flex: 1, fontSize: '14px', color: '#f1f5f9', fontWeight: 600 }}>
                                {lathe.type}
                              </span>
                              <span style={{ fontSize: '14px', color: '#cbd5e1' }}>
                                × {lathe.quantity}
                              </span>
                              <button
                                onClick={() => handleRemoveLathe(index)}
                                style={{
                                  background: 'rgba(239, 68, 68, 0.1)',
                                  border: '1px solid rgba(239, 68, 68, 0.3)',
                                  borderRadius: '6px',
                                  padding: '4px 8px',
                                  color: '#ef4444',
                                  fontSize: '11px',
                                  cursor: 'pointer',
                                  fontWeight: 600
                                }}
                              >
                                Remove
                              </button>
                            </div>
                          ))
                        ) : (
                          <div style={{ fontSize: '13px', color: '#64748b', fontStyle: 'italic', marginBottom: '12px' }}>
                            No lathes added yet
                          </div>
                        )}
                      </div>
                      
                      {/* Add New Lathe */}
                      <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                        <select
                          value={newLathe.type}
                          onChange={(e) => setNewLathe({ ...newLathe, type: e.target.value })}
                          style={{
                            flex: 1,
                            padding: '8px 12px',
                            background: 'rgba(15, 23, 42, 0.6)',
                            border: '1px solid rgba(148, 163, 184, 0.2)',
                            borderRadius: '8px',
                            color: '#f1f5f9',
                            fontSize: '14px',
                            outline: 'none',
                            cursor: 'pointer',
                            fontFamily: "'Manrope', -apple-system, sans-serif"
                          }}
                        >
                          {LATHE_TYPES.map(type => (
                            <option key={type} value={type}>{type}</option>
                          ))}
                        </select>
                        
                        <select
                          value={newLathe.quantity}
                          onChange={(e) => setNewLathe({ ...newLathe, quantity: parseInt(e.target.value) })}
                          style={{
                            width: '70px',
                            padding: '8px 12px',
                            background: 'rgba(15, 23, 42, 0.6)',
                            border: '1px solid rgba(148, 163, 184, 0.2)',
                            borderRadius: '8px',
                            color: '#f1f5f9',
                            fontSize: '14px',
                            outline: 'none',
                            cursor: 'pointer',
                            fontFamily: "'Manrope', -apple-system, sans-serif"
                          }}
                        >
                          {Array.from({ length: 20 }, (_, i) => i + 1).map(num => (
                            <option key={num} value={num}>{num}</option>
                          ))}
                        </select>
                        
                        <button
                          onClick={handleAddLathe}
                          style={{
                            padding: '8px 12px',
                            background: 'linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)',
                            border: 'none',
                            borderRadius: '8px',
                            color: '#fff',
                            fontSize: '12px',
                            fontWeight: 600,
                            cursor: 'pointer',
                            whiteSpace: 'nowrap'
                          }}
                        >
                          Add
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div>
                      {selectedCustomer.lathes && selectedCustomer.lathes.length > 0 ? (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                          {selectedCustomer.lathes.map((lathe, index) => (
                            <div key={index} style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              padding: '8px 12px',
                              background: 'rgba(6, 182, 212, 0.05)',
                              borderRadius: '8px',
                              border: '1px solid rgba(6, 182, 212, 0.1)'
                            }}>
                              <span style={{ fontSize: '16px', fontWeight: 700, color: '#10b981' }}>
                                {lathe.type}
                              </span>
                              <span style={{ fontSize: '16px', fontWeight: 600, color: '#cbd5e1' }}>
                                × {lathe.quantity}
                              </span>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <div style={{ fontSize: '14px', color: '#64748b', fontStyle: 'italic' }}>
                          No lathes on-site
                        </div>
                      )}
                    </div>
                  )}
                </div>

                <div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                    <CalendarIcon size={16} color="#06b6d4" />
                    <span style={{ fontSize: '12px', color: '#64748b', fontWeight: 600 }}>LAST CONTACT</span>
                  </div>
                  <div style={{ display: 'flex', gap: '8px', alignItems: 'center', marginBottom: '8px' }}>
                    {/* Month Dropdown */}
                    <select
                      value={new Date(selectedCustomer.lastContact).getMonth() + 1}
                      onChange={(e) => {
                        const date = new Date(selectedCustomer.lastContact);
                        const newDate = new Date(date.getFullYear(), parseInt(e.target.value) - 1, date.getDate());
                        const dateString = newDate.toISOString().split('T')[0];
                        const updatedCustomers = customers.map(c => 
                          c.id === selectedCustomer.id 
                            ? { ...c, lastContact: dateString, status: getStatusFromDate(dateString) }
                            : c
                        );
                        setCustomers(updatedCustomers);
                        setSelectedCustomer({
                          ...selectedCustomer,
                          lastContact: dateString,
                          status: getStatusFromDate(dateString)
                        });
                      }}
                      style={{
                        flex: 1,
                        padding: '8px 12px',
                        background: 'rgba(15, 23, 42, 0.6)',
                        border: '1px solid rgba(148, 163, 184, 0.2)',
                        borderRadius: '8px',
                        color: '#f1f5f9',
                        fontSize: '14px',
                        outline: 'none',
                        cursor: 'pointer',
                        fontFamily: "'Manrope', -apple-system, sans-serif"
                      }}
                    >
                      <option value="1">January</option>
                      <option value="2">February</option>
                      <option value="3">March</option>
                      <option value="4">April</option>
                      <option value="5">May</option>
                      <option value="6">June</option>
                      <option value="7">July</option>
                      <option value="8">August</option>
                      <option value="9">September</option>
                      <option value="10">October</option>
                      <option value="11">November</option>
                      <option value="12">December</option>
                    </select>
                    
                    {/* Day Dropdown */}
                    <select
                      value={new Date(selectedCustomer.lastContact).getDate()}
                      onChange={(e) => {
                        const date = new Date(selectedCustomer.lastContact);
                        const newDate = new Date(date.getFullYear(), date.getMonth(), parseInt(e.target.value));
                        const dateString = newDate.toISOString().split('T')[0];
                        const updatedCustomers = customers.map(c => 
                          c.id === selectedCustomer.id 
                            ? { ...c, lastContact: dateString, status: getStatusFromDate(dateString) }
                            : c
                        );
                        setCustomers(updatedCustomers);
                        setSelectedCustomer({
                          ...selectedCustomer,
                          lastContact: dateString,
                          status: getStatusFromDate(dateString)
                        });
                      }}
                      style={{
                        flex: 0.5,
                        padding: '8px 12px',
                        background: 'rgba(15, 23, 42, 0.6)',
                        border: '1px solid rgba(148, 163, 184, 0.2)',
                        borderRadius: '8px',
                        color: '#f1f5f9',
                        fontSize: '14px',
                        outline: 'none',
                        cursor: 'pointer',
                        fontFamily: "'Manrope', -apple-system, sans-serif"
                      }}
                    >
                      {Array.from({ length: 31 }, (_, i) => i + 1).map(day => (
                        <option key={day} value={day}>{day}</option>
                      ))}
                    </select>
                    
                    {/* Year Dropdown */}
                    <select
                      value={new Date(selectedCustomer.lastContact).getFullYear()}
                      onChange={(e) => {
                        const date = new Date(selectedCustomer.lastContact);
                        const newDate = new Date(parseInt(e.target.value), date.getMonth(), date.getDate());
                        const dateString = newDate.toISOString().split('T')[0];
                        const updatedCustomers = customers.map(c => 
                          c.id === selectedCustomer.id 
                            ? { ...c, lastContact: dateString, status: getStatusFromDate(dateString) }
                            : c
                        );
                        setCustomers(updatedCustomers);
                        setSelectedCustomer({
                          ...selectedCustomer,
                          lastContact: dateString,
                          status: getStatusFromDate(dateString)
                        });
                      }}
                      style={{
                        flex: 0.7,
                        padding: '8px 12px',
                        background: 'rgba(15, 23, 42, 0.6)',
                        border: '1px solid rgba(148, 163, 184, 0.2)',
                        borderRadius: '8px',
                        color: '#f1f5f9',
                        fontSize: '14px',
                        outline: 'none',
                        cursor: 'pointer',
                        fontFamily: "'Manrope', -apple-system, sans-serif"
                      }}
                    >
                      {Array.from({ length: 10 }, (_, i) => 2025 - i).map(year => (
                        <option key={year} value={year}>{year}</option>
                      ))}
                    </select>
                  </div>
                  
                  <button
                    onClick={() => {
                      const today = new Date().toISOString().split('T')[0];
                      const updatedCustomers = customers.map(c => 
                        c.id === selectedCustomer.id 
                          ? { ...c, lastContact: today, status: getStatusFromDate(today) }
                          : c
                      );
                      setCustomers(updatedCustomers);
                      setSelectedCustomer({
                        ...selectedCustomer,
                        lastContact: today,
                        status: getStatusFromDate(today)
                      });
                    }}
                    style={{
                      width: '100%',
                      padding: '8px 12px',
                      background: 'linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)',
                      border: 'none',
                      borderRadius: '8px',
                      color: '#fff',
                      fontSize: '13px',
                      fontWeight: 600,
                      cursor: 'pointer',
                      transition: 'all 0.2s'
                    }}
                    onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.02)'}
                    onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
                  >
                    Set to Today
                  </button>
                </div>

                {/* Notes Section */}
                <div>
                  <div style={{ fontSize: '12px', color: '#64748b', fontWeight: 600, marginBottom: '8px' }}>
                    NOTES
                  </div>
                  
                  {/* Add New Note */}
                  <div style={{ display: 'flex', gap: '8px', marginBottom: '12px' }}>
                    <input
                      type="text"
                      value={newNote}
                      onChange={(e) => setNewNote(e.target.value)}
                      onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                          handleAddNote();
                        }
                      }}
                      placeholder="Add a note..."
                      style={{
                        flex: 1,
                        padding: '10px 12px',
                        background: 'rgba(15, 23, 42, 0.6)',
                        border: '1px solid rgba(148, 163, 184, 0.2)',
                        borderRadius: '8px',
                        color: '#f1f5f9',
                        fontSize: '14px',
                        outline: 'none',
                        fontFamily: "'Manrope', -apple-system, sans-serif"
                      }}
                      onFocus={(e) => e.target.style.borderColor = '#06b6d4'}
                      onBlur={(e) => e.target.style.borderColor = 'rgba(148, 163, 184, 0.2)'}
                    />
                    <button
                      onClick={handleAddNote}
                      style={{
                        padding: '10px 16px',
                        background: 'linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)',
                        border: 'none',
                        borderRadius: '8px',
                        color: '#fff',
                        fontSize: '13px',
                        fontWeight: 600,
                        cursor: 'pointer',
                        transition: 'all 0.2s'
                      }}
                      onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                      onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
                    >
                      Add
                    </button>
                  </div>
                  
                  {/* Notes List - Most recent at top */}
                  <div style={{ 
                    maxHeight: '200px',
                    overflowY: 'auto',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '8px'
                  }}>
                    {selectedCustomer.notes && selectedCustomer.notes.length > 0 ? (
                      selectedCustomer.notes.map((note, index) => (
                        <div 
                          key={index}
                          style={{ 
                            fontSize: '14px', 
                            color: '#cbd5e1', 
                            background: 'rgba(6, 182, 212, 0.05)',
                            padding: '10px 12px',
                            borderRadius: '8px',
                            border: '1px solid rgba(6, 182, 212, 0.1)',
                            lineHeight: 1.5
                          }}
                        >
                          <div style={{ marginBottom: '4px' }}>{note.text}</div>
                          <div style={{ 
                            fontSize: '11px', 
                            color: '#64748b',
                            fontStyle: 'italic'
                          }}>
                            {new Date(note.timestamp).toLocaleDateString('en-US', { 
                              month: 'short', 
                              day: 'numeric', 
                              year: 'numeric' 
                            })}
                          </div>
                        </div>
                      ))
                    ) : (
                      <div style={{ 
                        fontSize: '13px', 
                        color: '#64748b',
                        fontStyle: 'italic',
                        textAlign: 'center',
                        padding: '12px'
                      }}>
                        No notes yet
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div style={{ 
                display: 'flex', 
                gap: '8px', 
                marginTop: '24px',
                paddingTop: '20px',
                borderTop: '1px solid rgba(148, 163, 184, 0.1)'
              }}>
                {isEditing ? (
                  <>
                    <button 
                      onClick={handleSaveEdit}
                      style={{
                        flex: 1,
                        background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                        border: 'none',
                        borderRadius: '10px',
                        padding: '12px',
                        color: '#fff',
                        fontWeight: 700,
                        fontSize: '13px',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '8px'
                      }}
                    >
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="20 6 9 17 4 12"></polyline>
                      </svg>
                      Save
                    </button>
                    <button 
                      onClick={handleCancelEdit}
                      style={{
                        flex: 1,
                        background: 'rgba(148, 163, 184, 0.1)',
                        border: '1px solid rgba(148, 163, 184, 0.3)',
                        borderRadius: '10px',
                        padding: '12px',
                        color: '#cbd5e1',
                        fontWeight: 700,
                        fontSize: '13px',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '8px'
                      }}
                    >
                      <XIcon size={16} />
                      Cancel
                    </button>
                  </>
                ) : (
                  <>
                    <button 
                      onClick={handleEdit}
                      style={{
                        flex: 1,
                        background: 'linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)',
                        border: 'none',
                        borderRadius: '10px',
                        padding: '12px',
                        color: '#fff',
                        fontWeight: 700,
                        fontSize: '13px',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '8px'
                      }}
                    >
                      <EditIcon size={16} color="#fff" />
                      Edit
                    </button>
                    <button 
                      onClick={() => handleDeleteCustomer(selectedCustomer.id)}
                      style={{
                        background: 'rgba(239, 68, 68, 0.1)',
                        border: '1px solid rgba(239, 68, 68, 0.3)',
                        borderRadius: '10px',
                        padding: '12px',
                        color: '#ef4444',
                        fontWeight: 700,
                        fontSize: '13px',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      <TrashIcon size={16} color="#ef4444" />
                    </button>
                  </>
                )}
              </div>
            </div>
          )}
        </div>
      </div>

      <style>{`
        @keyframes slideIn {
          from {
            opacity: 0;
            transform: translateX(-20px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes dropIn {
          from {
            opacity: 0;
            transform: translate(-50%, -100%) scale(0);
          }
          to {
            opacity: 1;
            transform: translate(-50%, -100%) scale(1);
          }
        }

        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }

        @keyframes slideInRight {
          from {
            opacity: 0;
            transform: translateX(30px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes pulse {
          0% {
            transform: translate(-50%, -50%) scale(1);
            opacity: 0.5;
          }
          100% {
            transform: translate(-50%, -50%) scale(2.5);
            opacity: 0;
          }
        }

        @keyframes pulse-marker {
          0%, 100% {
            box-shadow: 0 0 0 0 rgba(239, 68, 68, 0.7);
          }
          50% {
            box-shadow: 0 0 0 10px rgba(239, 68, 68, 0);
          }
        }

        @keyframes spin {
          to {
            transform: rotate(360deg);
          }
        }

        /* Scrollbar styling */
        ::-webkit-scrollbar {
          width: 8px;
        }

        ::-webkit-scrollbar-track {
          background: rgba(15, 23, 42, 0.3);
        }

        ::-webkit-scrollbar-thumb {
          background: rgba(6, 182, 212, 0.3);
          border-radius: 4px;
        }

        ::-webkit-scrollbar-thumb:hover {
          background: rgba(6, 182, 212, 0.5);
        }

        /* Leaflet custom styles */
        .leaflet-container {
          font-family: 'Manrope', -apple-system, sans-serif;
        }

        .custom-marker {
          background: transparent;
          border: none;
        }

        .leaflet-popup-content-wrapper {
          border-radius: 10px;
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
        }

        .leaflet-popup-tip {
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
        }
      `}</style>
    </div>
  );
};

export default MapCRM;